export default "__VITE_ASSET__DhKc12ja__"